module.exports = __webpack_public_path__ + "img/drt7.164dccff.png";